module.exports = __webpack_public_path__ + "static/media/mortar-pestle.9b7d70df.svg";